import { useState, useEffect } from 'react';

/**
 * Возвращает значение, обновлённое с задержкой после последнего изменения исходного значения.
 * @param value - исходное значение (например, строка поиска)
 * @param delayMs - задержка в миллисекундах
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debouncedValue;
}
